<template>
<!--  <div id="main" @click.prevent="hideUserMenu">-->
  <div id="main">
    <div class="global_top">
      <div>
        <div class="logo_wrap">
          <img src="../assets/common/kepcologo.svg"/>
        </div>
        <div class="menu_wrap">
          <div
            class="menu_item"
            :class="{on: currentPath === 'Dashboard'}"
            @click="movePath('/Dashboard')">
            대시보드
          </div>
          <div
            class="menu_item"
            :class="{on: item.menuPath != null && item.menuPath.split('/')[1] === currentPath}"
            :key="'menu_' + item.menuPid"
            v-for="item in menuInfo"
            @click="movePath(item.menuPath)" v-if="item.menuPid < 8">
            {{item.menuName}}
          </div>
        </div>
        <div class="profile_wrap">
<!--          <div class="alarm_wrap">-->
<!--            <div class="btn_alarm">알람 열기 버튼</div>-->
<!--            <div class="unread_alarm">읽지 않은 알람이 있습니다.</div>-->
<!--          </div>-->
          <div class="btn_menu" @click.stop="toggleUserMenu">사용자 메뉴 버튼</div>
          <div class="profile">
            <img/>
          </div>
          <div class="user_menu_wrap" v-if="isShowUserMenu">
            <div @click.stop="movePath('/MyInfo')">내 정보 수정</div>
            <div class="btn_logout" @click.stop="logout">로그아웃</div>
          </div>
        </div>
      </div>
    </div>
    <div class="global_content">
      <router-view @setMenu="setMenu"/>
    </div>
    <div class="global_bottom">
      <div>
        <div>웹사이트 이용문의 : test@test.com 고객 문의의 원할한 적기 처리 및 이력 관리를 위해 위 번호로 문의 주시기 바랍니다. Copyright ⓒ LG Uplus Corp. All Rights Reserved.</div>
        <div>
          <select>
            <option>패밀리사이트</option>
          </select>
          <img src="../assets/main/bg_main_kepc_logo.png"/>
          <img src="../assets/main/bg_main_lguplus_logo.png"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../script/common'
import menuInfo from '../script/menuInfo'

export default {
  data () {
    return {
      userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
      // menu
      currentPath: '',
      menuInfo: [],
      // profile
      isUnread: false,
      isShowUserMenu: false
    }
  },
  mounted () {
    common.setCommonCode()
    this.getMenuInfo()
  },
  methods: {
    getMenuInfo () {
      menuInfo.getMenuInfo({
        menu: true
      }, response => {
        console.log('getMenuInfo', response)
        if (response.data.resultCode === 1) {
          sessionStorage.setItem('menuInfo', response.data.resultCode === 1 ? JSON.stringify(response.data.result.body) : '[]')
          this.menuInfo = response.data.result.body
        }
      })
    },
    setMenu (args) {
      this.currentPath = args
    },
    movePath (path) {
      this.hideUserMenu()
      if (path != null) {
        this.$router.push(path)
      }
    },
    toggleUserMenu () {
      this.isShowUserMenu = !this.isShowUserMenu
    },
    hideUserMenu () {
      this.isShowUserMenu = false
    },
    logout () {
      sessionStorage.clear()
      this.$router.replace('/Login')
    }
  }
}
</script>

<style scoped>
#main {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
}

.global_top {
  display: flex;
  min-width: 1440px;
  height: 64px;
  border-bottom: 1px solid #E4E6E8;
  margin: 0;
  box-sizing: border-box;
}

.global_top > div {
  display: flex;
  width: 1440px;
  margin: 0 auto;
}

.global_top > div > .logo_wrap {
  display: flex;
  width: 200px;
  height: 48px;
  margin: auto 0 auto 10px;
}

.global_top > div > .logo_wrap > img {
  width: 100%;
}

.global_top > div > .menu_wrap {
  display: flex;
  margin: auto 0 auto 30px;
  gap: 28px;
}

.global_top > div > .menu_wrap > .menu_item {
  line-height: 18px;
  color: #171721;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.global_top > div > .menu_wrap > .menu_item.on {
  color: #3E7EFF;
}

.global_top > div > .profile_wrap {
  position: relative;
  display: flex;
  margin: auto 30px auto auto;
  gap: 8px;
}

.global_top > div > .profile_wrap > div {
  cursor: pointer;
}

.global_top > div > .profile_wrap > .alarm_wrap {
  position: relative;
  display: flex;
  margin: auto 0;
}

.global_top > div > .profile_wrap > .alarm_wrap > .btn_alarm {
  width: 18px;
  height: 18px;
  padding: 13px;
  background: url('../assets/main/ic_alarm.svg') center center no-repeat;
  text-indent: -9999em;
}

.global_top > div > .profile_wrap > .alarm_wrap > .unread_alarm {
  position: absolute;
  top: 6px;
  right: 9px;
  width: 5px;
  height: 5px;
  background: url('../assets/main/ic_unread_alarm.svg') 0 0 no-repeat;
  text-indent: -9999em;
}

.global_top > div > .profile_wrap > .btn_menu {
  width: 18px;
  height: 18px;
  padding: 13px;
  margin: auto 0;
  background: url('../assets/main/ic_menu.svg') center center no-repeat;
  text-indent: -9999em;
}

.global_top > div > .profile_wrap > .profile {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  margin: auto 0;
  background: lightgray;
  text-indent: -9999em;
}

.global_top > div > .profile_wrap > .profile > img {
  width: 36px;
  height: 36px;
  object-fit: cover;
}

.global_top > div > .profile_wrap > .user_menu_wrap {
  position: absolute;
  top: 40px;
  right: 40px;
  width: 100px;
  height: 60px;
  padding: 15px;
  border-radius: 5px;
  background: #ffffff;
  box-shadow: 0 5px 15px 0 rgba(38, 45, 51, 0.3);
  z-index: 2;
}

.global_top > div > .profile_wrap > .user_menu_wrap > div {
  line-height: 30px;
  font-size: 12px;
  cursor: pointer;
}

.global_top > div > .profile_wrap > .user_menu_wrap > div:hover {
  background: rgba(0, 0, 255, 0.1);
}

.global_content {
  min-width: 1440px;
}

.global_bottom {
  display: flex;
  min-width: 1440px;
  height: 66px;
  margin: auto 0 0;
  background: #F5F5FA;
}

.global_bottom > div {
  display: flex;
  width: 1440px;
  margin: 0 auto;
}

.global_bottom > div > div:nth-child(1) {
  margin: auto 0 auto 28px;
  line-height: 18px;
  color: #8083A3;
  font-size: 12px;
  font-weight: 600;
}

.global_bottom > div > div:nth-child(2) {
  display: flex;
  margin: auto 30px auto auto;
  gap: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue